import Image from "next/image";
import Heading from "~/componentsDS/Typography/Heading";

type MonitoringCardProps = {
    imageUrl?: string;
    alt?: string;
    className?: string;
};

const defaultImage = "https://res.cloudinary.com/dirscuuhp/image/upload/c_crop,w_1155,h_1323,x_0,y_210/v1775832212/new_design/665af5efa01ac1a3e3b908b8e28a11f4a40fb68f_1_hqzt77.webp"

const MonitoringCard = ({imageUrl= defaultImage, alt = "Woman feeling supported through ongoing menopause care", className = ""}:MonitoringCardProps) => {
    return (
        <div className={`relative h-[450px] w-[98%] overflow-hidden rounded-[16px] md:h-[554px] ${className}`}>
            <Image
                src={imageUrl}
                alt={alt}
                fill
                sizes="(max-width: 768px) 100vw, 800px"
                className="pointer-events-none object-cover"
            />

            <Heading
                as="h3"
                font="featureDisplay"
                weight="400"
                className="
                    relative z-[1] px-2 pt-8 text-center
                    text-[28px] !leading-[1.1] text-pureWhite
                    md:px-4 md:pt-[62px] md:text-[31.5px]
                "
            >
                Ongoing monitoring <br />
                — not one-time prescribing.
            </Heading>
        </div>
    );
};

export default MonitoringCard;
